// @see: https://github.com/js-cookie/js-cookie/blob/master/src/js.cookie.js
import Cookies from 'js-cookie';

import { logWarning } from './log';

export function getCookie(name: string): string | undefined | null {
  if (!name) {
    logWarning('Cookie name is required');
    return null;
  }

  return Cookies.get(name);
}

export function setCookie(name: string, value?: string | null, expires: number = 365): void {
  return Cookies.set(name, value, { expires });
}

export function deleteCookie(name: string): void {
  Cookies.remove(name);
}
